import { render } from "./ChallengeLayout.vue?vue&type=template&id=3a15639d&scoped=true"
import script from "./ChallengeLayout.vue?vue&type=script&lang=js"
export * from "./ChallengeLayout.vue?vue&type=script&lang=js"

import "./ChallengeLayout.vue?vue&type=style&index=0&id=3a15639d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a15639d"]])

export default __exports__